__turbopack_context__.v({
  "emptyResult": "AllProjects-module-scss-module__CqxKWq__emptyResult",
  "projects": "AllProjects-module-scss-module__CqxKWq__projects",
  "root": "AllProjects-module-scss-module__CqxKWq__root",
  "searchBar": "AllProjects-module-scss-module__CqxKWq__searchBar",
  "searchInput": "AllProjects-module-scss-module__CqxKWq__searchInput",
  "title": "AllProjects-module-scss-module__CqxKWq__title",
});
